exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-014d6284] {\n  margin-top: 20px;\n  height: 30px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 18px;\n  border-radius: 6px;\n  font-family: RobotoWeb, \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.button.is-link[data-v-014d6284] {\n  width: 155px;\n  margin-right: 10px;\n  background: #2B67DF;\n}\n.button.is-outlined[data-v-014d6284] {\n  background: #FFFFFF;\n  border: 1px solid #2B67DF;\n  box-sizing: border-box;\n  border-radius: 6px;\n  color: #2B67DF;\n  position: absolute;\n  width: 143px;\n}", ""]);

// exports
